import { useMemo } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import t from 'common/i18n';
import { StyledCombobox } from '../../../../common/combobox.jsx';
import { IMAGE_SIZE_OPTIONS } from '../../data/consts';

const SectionBox = styled.section`
  border-bottom: 1px solid ${(props) => props.theme.palette.secondary};
  padding: ${(props) => props.theme.spacing.md};
  label {
    font-weight: bold;
    white-space: nowrap;
    display: block;
    padding-bottom: ${(props) => props.theme.spacing.xs};
    font-size: ${(props) => props.theme.font.size.xs};
  }
  .uw-radio-group li .label {
    text-align: left;
  }
`;

const sizesToOptions = (asset) => {
  const options = IMAGE_SIZE_OPTIONS.map((item) => ({
    value: item.name,
    label: t(`unsplash.summary.size.${item.name}`) + ` (${Math.ceil((item.height * asset.width) / asset.height)}x${item.height})`,
    height: item.height,
  }));

  options.push({
    value: 'original_size',
    label: t('unsplash.summary.size.original_size') + ` (${asset.width}x${asset.height})`,
    height: asset.height,
  });
  return options;
};

export default ({ selectedAsset, selectedFormat, selectAssetFormat }) => {
  const items = useMemo(() => sizesToOptions(selectedAsset), [selectedAsset]);
  return (
    <SectionBox data-test="format-section">
      <label>{t('unsplash.summary.format')}</label>
      <StyledCombobox
        size="md"
        isSearchable={false}
        isClearable={false}
        placeholder={t('unsplash.select')}
        options={items}
        value={selectedFormat}
        onChange={selectAssetFormat}
      />
    </SectionBox>
  );
};
